export default [
    ['0', '服务'],
    ['1', '界面'],
    ['2', '程序库'],
]
